import {z} from 'zod';

export const isEmail = (value: string): boolean => z.email().safeParse(value).success;
